export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['required', 'requiredHidden', 'requiredReadOnly', 'requiredLocked', 'requiredPubliclyAvailable', 'requiredHiddenPubliclyAvailable', 'requiredReadOnlyPubliclyAvailable', 'requiredLockedPubliclyAvailable'],
    properties: {
      required: {
        title: 'Required Indicator',
        type: 'string'
      },
      hidden: {
        title: 'Hidden Indicator',
        type: 'string'
      },
      readOnly: {
        title: 'Read Only Indicator',
        type: 'string'
      },
      locked: {
        title: 'Locked Indicator',
        type: 'string'
      },
      publiclyAvailable: {
        title: 'Publicly Available Indicator',
        type: 'string'
      },
      requiredHidden: {
        title: 'Required and Hidden Indicators',
        type: 'string'
      },
      requiredReadOnly: {
        title: 'Required and Read-Only Indicators',
        type: 'string'
      },
      requiredLocked: {
        title: 'Required and Locked Indicators',
        type: 'string'
      },
      requiredPubliclyAvailable: {
        title: 'Required and Publicly Available Indicators',
        type: 'string'
      },
      requiredHiddenPubliclyAvailable: {
        title: 'Required, Hidden and Publicly Available Indicators',
        type: 'string'
      },
      requiredReadOnlyPubliclyAvailable: {
        title: 'Required, Read-Only and Publicly Available Indicators',
        type: 'string'
      },
      requiredLockedPubliclyAvailable: {
        title: 'Required, Locked and Publicly Available Indicators',
        type: 'string'
      },
      hiddenPubliclyAvailable: {
        title: 'Hidden and Publicly Available Indicators',
        type: 'string'
      },
      readOnlyPubliclyAvailable: {
        title: 'Read-Only and Publicly Available Indicators',
        type: 'string'
      },
      lockedPubliclyAvailable: {
        title: 'Locked and Publicly Available Indicators',
        type: 'string'
      },
      disabledFieldWithIcons: {
        title: 'Disabled Field with Indicators',
        type: 'string'
      },
      city: {
        title: 'City',
        type: 'string'
      },
      state: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      departments: {
        title: 'Departments',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            department: {
              title: 'Department',
              type: 'string',
              enum: ['Accounting', 'Finance', 'Economics'],
              enumNames: ['Accounting', 'Finance', 'Economics']
            }
          }
        }
      },
      static_labelled: {
        type: 'object',
        properties: {
          sample_question: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        title: 'Labelled Static Component'
      }
    }
  },
  uiSchema: {
    required: {
      'ui:widget': 'text'
    },
    hidden: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['HIDDEN']
      }
    },
    readOnly: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['READ_ONLY']
      }
    },
    locked: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['LOCKED']
      }
    },
    publiclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE']
      }
    },
    requiredHidden: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE']
      }
    },
    requiredReadOnly: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE']
      }
    },
    requiredLocked: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE']
      }
    },
    requiredPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE']
      }
    },
    requiredHiddenPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'HIDDEN']
      }
    },
    requiredReadOnlyPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'READ_ONLY']
      }
    },
    requiredLockedPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'LOCKED']
      }
    },
    hiddenPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'HIDDEN']
      }
    },
    readOnlyPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'READ_ONLY']
      }
    },
    lockedPubliclyAvailable: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'LOCKED']
      }
    },
    disabledFieldWithIcons: {
      'ui:widget': 'text',
      'ui:disabled': true,
      'ui:options': {
        icons: ['LOCKED']
      }
    },
    group_cityStateCountry: {
      'ui:title': 'City, State and Country',
      'ui:options': {
        icons: ['READ_ONLY']
      }
    },
    city: {
      'ui:widget': 'text'
    },
    state: {
      'ui:widget': 'select'
    },
    country: {
      'ui:widget': 'select'
    },
    departments: {
      'ui:options': {
        itemName: 'Department',
        icons: ['READ_ONLY']
      },
      items: {
        department: {
          'ui:widget': 'select'
        },
        'dm:layout': [{
          id: 'department',
          type: 'field'
        }]
      }
    },
    static_labelled: {
      'ui:options': {
        icons: ['READ_ONLY']
      },
      'dm:layout': [{
        id: 'sample_question',
        type: 'field'
      }],
      sample_question: {
        'ui:title': {
          text: 'Sample Question',
          escape: false
        },
        'ui:widget': 'text'
      }
    },
    'dm:layout': [{
      type: 'field',
      id: 'required'
    }, {
      type: 'field',
      id: 'hidden'
    }, {
      type: 'field',
      id: 'readOnly'
    }, {
      type: 'field',
      id: 'locked'
    }, {
      type: 'field',
      id: 'publiclyAvailable'
    }, {
      type: 'field',
      id: 'requiredHidden'
    }, {
      type: 'field',
      id: 'requiredReadOnly'
    }, {
      type: 'field',
      id: 'requiredLocked'
    }, {
      type: 'field',
      id: 'requiredPubliclyAvailable'
    }, {
      type: 'field',
      id: 'requiredHiddenPubliclyAvailable'
    }, {
      type: 'field',
      id: 'requiredReadOnlyPubliclyAvailable'
    }, {
      type: 'field',
      id: 'requiredLockedPubliclyAvailable'
    }, {
      type: 'field',
      id: 'hiddenPubliclyAvailable'
    }, {
      type: 'field',
      id: 'readOnlyPubliclyAvailable'
    }, {
      type: 'field',
      id: 'lockedPubliclyAvailable'
    }, {
      type: 'field',
      id: 'disabledFieldWithIcons'
    }, {
      id: 'group_cityStateCountry',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city'
      }, {
        type: 'field',
        id: 'state'
      }, {
        type: 'field',
        id: 'country'
      }]
    }, {
      type: 'array',
      id: 'departments'
    }, {
      id: 'static_labelled',
      type: 'field'
    }]
  },
  formData: {
    disabledFieldWithIcons: 'Some value'
  }
};